const ar = {

  navbar: {
    logo: "المثقفون",
    listItems: ["المنتجات", "المصادر", "مجتمعنا", "الأسعار"]
  },
  hero: {
    bigTitle: 'المثقفون ',
    description: "مرحبا بكم في عالم عشاق الأدب! انغمس في أرض العجائب الكتابية لدينا حيث تنبض الصفحات بالحياة.",
    image: "/2.jpg",
    btnText: "انضم للنادي "
  },
  currentReading: {
    bigTitle: 'قائمة القراءة الحالية',
    list: [
      {
        title: "السحر الغامض",
        description: "احصل على السحر من خلال أداة تقليب الصفحات الرائعة هذه."
      },
      {
        title: "السجلات الكونية ",
        description: " انطلق في مغامرة بين النجوم ذات أبعاد أسطورية."
      },
      {
        title: "حكايات خالدة ",
        description: "قم بإعادة النظر في القصص الأسطورية التي شكلت الأجيال."
      },
      {
        title: "البيانات الحديثة ",
        description: "استكشف الرواد الأدبيين الذين يقومون بتفكيك الأحداث الدنيوية."
      },
      {
        title: " الخرافات الوهمية",
        description: "انغمس في المناظر الطبيعية السريالية لهذه التخيلات الدنيوية الأخرى."
      },
      {
        title: "العلم المحرم ",
        description: "اكتشف الحقائق المخفية من المخطوطات القديمة المنسية منذ زمن طويل."
      },

    ]
  },
  club: {
    bigTitle: "النادي",
    cards: [
      {
        title: "أجواء النادي",
        description: "احصل على الراحة وسط بحر من الوسائد بينما نناقش أحدث القراءات.",
        image: "/club.jpg"
      },
      {
        title: "الشاي والمجلدات",
        description: "استمتع بفنجان من القهوة الدافئة بينما تفكر في النثر والشعر.",
        image: "/tea.jpg"
      },
      {
        title: "الملاذ الأخضر",
        description: "استمتع بالأجواء الهادئة والمفعمة بالأخضر في ملاذ الكتب الخاص بنا.",
        image: "/green.jpg"
      },
      {
        title: "مدة الصلاحية",
        description: "شاهد الأبراج المجيدة للكلمة المطبوعة التي تصل إلى السماء.",
        image: "/Shelf.jpg"
      },


    ]
  },

  meetings: {
    bigTitle: 'الإجتماعات',
    description: "استعد لبدأ صفحة جديدة كل أسبوع عندما ندخل في عالم الحبر و الورق  الغامض",
    image: '/1.jpg'
  },
  ready: {
    bigTitle: "هل انت مستعد؟ ",
    description: "هل أنت مستعد للانضمام إلى سجلات Bookworms Bookclub؟ أطلق العنان لعشاق الكتب في داخلك!",
    signup: "سجل الأن ",
    more: "قراءة المزيد"
  }
  , footer: " المثقفون "

}




export default ar
